var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThunderGreyVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9988 9.41016H10.7637L12.0388 1.28341C12.2209 0.122444 10.7182 -0.458038 10.0351 0.435011L0.654304 12.8037C0.107849 13.5182 0.654304 14.5898 1.56506 14.5898H5.80009L4.47949 22.7166C4.29734 23.8776 5.80009 24.458 6.48316 23.565L15.864 11.1963C16.456 10.4372 15.9095 9.41016 14.9988 9.41016Z",
    fill: "#AAB2AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderGreyVector);
export default __webpack_public_path__ + "static/media/thunder_grey_vector.4de90446c6cf41d74a5ca6b2c1755493.svg";
export { ForwardRef as ReactComponent };